export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
		{
			text: 'Margen de ganancia',
			key: 'percentage',
			type: 'number',
		},
	],
	plural_model_name_spanish: 'Listas de precios',
	singular_model_name_spanish: 'Lista de precios',
	create_model_name_spanish: 'Nueva lista de precios',
	text_delete: 'la',
}